import {
	trigger,
	transition,
	animate,
	keyframes,
	style,
} from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'app-onboarding-container',
	templateUrl: './onboarding-container.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('pop', [
			transition(
				'false <=> true',
				animate(
					'800ms ease-in',
					keyframes([
						style({ transform: 'scale(0.1)', offset: 0 }), // Original size
						style({ transform: 'scale(1.2)', offset: 0.6 }), // Grows to 150%
						style({ transform: 'scale(1)', offset: 0.8 }), // Grows to 150%
					]),
				),
			),
		]),
	],
	standalone: false,
})
export class OnboardingContainerComponent {
	@Input() playAnimation: boolean = false;
	@Input() imageUrl: string;
	@Input() headingText: string;
	@Input() subText: string;
	@Input() paragraphText: string;
	@Input() alternativeText: string;
}
